module.exports = __webpack_public_path__ + "img/vector-2@2x.de7b28d7.png";